/** Number of records shown per page in all paginated tables. */
export const TABLE_PAGE_SIZE = 10;

/** Number of recent records shown in dashboard preview tables (no pagination). */
export const DASHBOARD_PREVIEW_SIZE = 5;
